export function formatCurrency(amount, currency = "NGN" ) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
}

const formatKey = (key) =>
    key
        .replace(/^can/, 'Can') // replace starting "can" with "Can"
        .replace(/([A-Z])/g, ' $1') // insert spaces before caps
        .trim();


export function buildPermissionLabel(key, entity) {
    return `${formatKey(key)} ${entity}`;
}
